import { request } from '@umijs/max';
import type { AppBoxListParams, AppBoxListResponse, KnowledgeItem, KnowledgeListItem, KnowledgeListParams, KnowledgeListResponse, RagflowResponse, TenantInfo } from './data';
import { DEFAULT_PAGE_SIZE } from '@/constants/pagination';
import { AppListItem } from '@/pages/app/mine/data';


// 获取知识库列表 
export async function getKnowledgeList(params: KnowledgeListParams) {
    if (!params.pageNum) params.pageNum = 1;
    if (!params.pageSize) params.pageSize = DEFAULT_PAGE_SIZE;
    const res = await request<KnowledgeListResponse>("/api/knowledgeAdmin/searchKnowledgeConfigPage", {
        method: 'POST',
        data: params,
    });
    return res;
}

// 获取下拉的知识库列表 
export async function getKnowledgeBoxList(params: AppBoxListParams) {
    const res = await request<AppBoxListResponse>("/api/knowledgeAdmin/searchKnowledgeConfigList", {
        method: 'POST',
        data: params,
    });
    return res;
}
// 获取应用列表 POST /appAdmin/getAppBoxList
export async function getAppBoxList(params: AppBoxListParams) {
    const res = await request<AppBoxListResponse>("/api/appAdmin/getAppBoxList", {
        method: 'POST',
        data: params,
    });
    return res;
}

// 添加知识库
export async function createKnowledge(data: Partial<AppListItem>) {
    if (!data.appName) throw new Error('Name is required');
    const res = await request<API.RESPONSE>("/api/knowledgeAdmin/addKnowledgeConfig", {
        method: 'POST',
        data: data,
    });
    return res;
}

// 更新知识库
export async function updateKnowledge(data: Partial<KnowledgeListItem>) {
    if (!data.appId) throw new Error('App ID is required');
    const res = await request<API.RESPONSE>("/api/knowledgeAdmin/updateKnowledgeConfig", {
        method: 'POST',
        data: data,
    });
    return res;
}

// 获取知识库详情
export async function getKnowledgeDetail(id: string) {
    if (!id) throw new Error('ID is required');
    const res = await request<API.RESPONSE>('/api/knowledgeAdmin/getKnowledgeConfigDetailById', {
        method: 'POST',
        data: {
            appId: id,
        },
    });
    return res;
}

// 软删除知识库
export async function deleteKnowledge(appId: number | string) {
    if (!appId) throw new Error('App ID is required');
    const res = await request<API.RESPONSE>('/api/knowledgeAdmin/deleteKnowledgeConfig', {
        method: 'POST',
        data: { appId },
    });
    return res;
}

// 启用禁用知识库
export async function enableDisableKnowledge(data: { id: string; status: number }) {
    if (!data.id) throw new Error('ID is required');
    const res = await request<API.RESPONSE>('/api/appAdmin/enableAppConfig', {
        method: 'POST',
        data: {
            appId: data.id,
            status: data.status,
        },
    });
    return res;
}


// RAGFlow 知识库相关接口

const RAGFLOW_API_PREFIX = '/v1/kb';

// export async function getKnowledgeList(params: KnowledgeListParams) {
//     const res = await request<RagflowResponse<{ kbs: KnowledgeItem[]; total: number }>>(`${RAGFLOW_API_PREFIX}/list`, {
//         method: 'POST',
//         params: {
//             page: params.current || 1,
//             page_size: params.pageSize || 20,
//             keywords: params.name || '',
//             orderby: 'create_time',
//             desc: true,
//         },
//         data: {},
//     });

//     const kbs = res.data?.kbs || [];
//     const mappedData = kbs.map((item) => ({
//         ...item,
//         company: 'My Company', // TODO: Fetch from tenant info
//     }));

//     return {
//         data: mappedData,
//         total: res.data?.total || 0,
//         success: true,
//     };
// }

export async function rag_getKnowledgeDetail(id: string) {
    if (!id) throw new Error('ID is required');
    const res = await request<RagflowResponse<KnowledgeItem>>(`${RAGFLOW_API_PREFIX}/detail`, {
        method: 'GET',
        params: {
            kb_id: id,
        },
    });
    return res;
}

export async function rag_createKnowledge(data: Partial<KnowledgeItem>) {
    if (!data.name) throw new Error('Name is required');
    const res = await request<RagflowResponse<KnowledgeItem>>(`${RAGFLOW_API_PREFIX}/create`, {
        method: 'POST',
        data: data,
    });
    return res;
}

export async function rag_updateKnowledge(data: Partial<KnowledgeItem>) {
    if (!data.id) throw new Error('ID is required');
    const res = await request<RagflowResponse<KnowledgeItem>>(`${RAGFLOW_API_PREFIX}/update`, {
        method: 'POST',
        data: {
            kb_id: data.id,
            name: data.name,
            avatar: data.avatar,
            description: data.description,
            language: data.language,
            permission: data.permission,
            embd_id: data.embd_id,
            parser_id: data.parser_id,
            parser_config: data.parser_config,
        },
    });
    return res;
}

export async function rag_removeKnowledge(data: { id: string[] }) {
    await Promise.all(data.id.map(async (id) => {
        return request<RagflowResponse<any>>(`${RAGFLOW_API_PREFIX}/rm`, {
            method: 'POST',
            data: {
                kb_id: id,
            },
        });
    }));

    return { success: true };
}

// 获取用户全局配置信息
export async function rag_getUserGlobalConfig() {
    const res = await request<RagflowResponse<TenantInfo>>('/v1/user/tenant_info', {
        method: 'GET',
    });
    return res;
}
